// extracted by mini-css-extract-plugin
export default {"container":"UserCoupon_container__7I1Im","card":"UserCoupon_card__hzIrr","title":"UserCoupon_title__pD80R"};